/* =========================================================================
   amor-cart.js · Warenkorb „Ruhig“ (Drawer + Warenkorbseite) · AMOR 10/2026
   -------------------------------------------------------------------------
   Wird von snippets/cart-drawer.liquid geladen (auf jeder Seite, nach den
   Sahara-Skripten cart.js und cart-drawer.js). Menge ändern und Entfernen
   macht weiterhin Sahara; diese Datei ergänzt:
   - Gutscheincode einlösen/entfernen (Shopify /cart/update.js „discount“)
   - vorgemerkte Codes anzeigen, die noch nicht greifen (z. B. aus dem QR-Code
     auf dem Kassenbon, amor.de/discount/CODE, Mindestbestellwert noch nicht erreicht)
   - „Rückgängig“ nach dem Entfernen
   - Hinweis „Hinzugefügt: …“ nach dem Hinzufügen
   - „Passt dazu“ (gepflegte Ergänzungen, sonst „Beliebte Ergänzungen“ aus den
     Bestsellern anderer Produktarten) und „Zuletzt angesehen“
   - voraussichtliches Lieferdatum in der Service-Box
   - Sperre von „Zur Kasse“, solange ein Artikel ausverkauft ist
   - Bestellnotiz sofort speichern
   - Handy-Leiste mit Summe und „Zur Kasse“ auf der Warenkorbseite
   - Drawer und Warenkorbseite bleiben gleich (auf /cart beide aktuell)
   - Produktkacheln: „+“ bei Produkten mit mehreren Varianten öffnet das
     Schnellfenster (snippets/amor-kachel-auswahl.liquid), danach der Warenkorb
   Fällt die Datei aus, funktioniert der Warenkorb trotzdem (ohne diese Extras).
   ========================================================================= */
(function () {
  'use strict';

  if (window.AmorWarenkorb) {
    return;
  }

  /* ---------- Einstellungen ---------- */
  // Lieferdatum in der Service-Box. Ganz abschalten: var LIEFERUNG = null;  → dann steht der feste Text
  // aus snippets/amor-cart-service.liquid („Kostenloser Versand · Lieferzeit 2–3 Werktage“).
  var LIEFERUNG = {
    von: 2, // Werktage ab heute (Mo–Fr), früheste Lieferung
    bis: 3, // späteste Lieferung
    annahmeschluss: null // z. B. 14 = ab 14 Uhr zählt der nächste Tag; null = aus
  };
  // weitere Tage ohne Versand, Format 'JJJJ-MM-TT', z. B. ['2026-12-24', '2026-12-31']
  var FREIE_TAGE = [];

  var EN = (document.documentElement.lang || '').toLowerCase().indexOf('en') === 0;
  var T = EN ? {
    hinzu: 'Added:',
    weg: function (t) { return '“' + t + '” removed.'; },
    zurueck: 'Undo',
    wieder: function (t) { return '“' + t + '” is back in your basket.'; },
    zurueckFehler: 'The item could not be restored.',
    dazuFehler: 'This item could not be added.',
    codeLeer: 'Please enter a code.',
    codeSchon: function (c) { return 'The code “' + c + '” has already been applied.'; },
    codeUngueltig: function (c) { return 'The code “' + c + '” is invalid or does not apply to your basket yet – for example because of a minimum order value.'; },
    codeOk: function (c) { return 'Code “' + c + '” applied.'; },
    codeWeg: 'Code removed.',
    codeVorgemerkt: 'Saved – it will be deducted automatically as soon as your basket meets the conditions (e.g. minimum order value).',
    codeSchonVorgemerkt: function (c) { return 'The code “' + c + '” is already saved and will be deducted automatically as soon as your basket meets the conditions.'; },
    code: 'Discount code',
    entfernen: 'Remove',
    fehler: 'Something went wrong. Please try again.',
    gesperrt: 'Please remove the sold-out item first.',
    lieferung: 'Expected delivery {von} – {bis} · free',
    tage: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
    monate: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
  } : {
    hinzu: 'Hinzugefügt:',
    weg: function (t) { return '„' + t + '“ entfernt.'; },
    zurueck: 'Rückgängig',
    wieder: function (t) { return '„' + t + '“ ist wieder im Warenkorb.'; },
    zurueckFehler: 'Der Artikel konnte nicht wiederhergestellt werden.',
    dazuFehler: 'Der Artikel konnte nicht hinzugefügt werden.',
    codeLeer: 'Bitte gib einen Code ein.',
    codeSchon: function (c) { return 'Der Code „' + c + '“ ist bereits eingelöst.'; },
    codeUngueltig: function (c) { return 'Der Code „' + c + '“ ist ungültig oder gilt noch nicht für deinen Warenkorb – zum Beispiel wegen eines Mindestbestellwerts.'; },
    codeOk: function (c) { return 'Code „' + c + '“ eingelöst.'; },
    codeWeg: 'Code entfernt.',
    codeVorgemerkt: 'Vorgemerkt – wird automatisch abgezogen, sobald dein Warenkorb die Bedingungen erfüllt (z. B. Mindestbestellwert).',
    codeSchonVorgemerkt: function (c) { return 'Der Code „' + c + '“ ist bereits vorgemerkt und wird automatisch abgezogen, sobald dein Warenkorb die Bedingungen erfüllt.'; },
    code: 'Gutscheincode',
    entfernen: 'Entfernen',
    fehler: 'Das hat leider nicht geklappt. Bitte versuche es noch einmal.',
    gesperrt: 'Bitte entferne zuerst den ausverkauften Artikel.',
    lieferung: 'Lieferung voraussichtlich {von} – {bis} · kostenlos',
    tage: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa']
  };

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var SYMBOL = {
    ok: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>',
    fehler: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" aria-hidden="true" focusable="false"><circle cx="12" cy="12" r="9"/><path d="M12 7.5v5.5M12 16.2v.3"/></svg>',
    // wie in snippets/amor-cart-code.liquid
    code: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M3 12V4h8l9 9-8 8z"/><circle cx="7.5" cy="7.5" r="1.2"/></svg>'
  };

  var zustand = { hinzu: null, weg: null, meldung: null, code: null, codeOffen: {} };
  var zaehler = { drawer: 0, seite: 0 };
  var schnellAusloeser = null; // zuletzt geklicktes „Auswählen“ im Drawer
  var kachelAuswahl = null; // „+“ einer Produktkachel, solange deren Schnellfenster offen ist
  var cache = {};

  /* ---------- Hilfen ---------- */
  function alle(selektor, el) {
    return Array.prototype.slice.call((el || document).querySelectorAll(selektor));
  }
  function seiteElement() {
    return document.querySelector('cart-items.amor-wk-seite-rahmen');
  }
  function seitenId() {
    var el = seiteElement();
    return el ? el.id : null;
  }
  function drawerBody() {
    return document.getElementById('CartDrawer-Body');
  }
  function drawerOffen() {
    var d = document.querySelector('cart-drawer');
    return !!(d && d.classList.contains('is-visible'));
  }
  function ortVon(el) {
    return el && el.closest && el.closest('#CartDrawer-Body') ? 'drawer' : 'seite';
  }
  function behaelter(ort) {
    return ort === 'drawer' ? drawerBody() : seiteElement();
  }
  function abschnitte() {
    var ids = ['cart-drawer', 'cart-counter'];
    var s = seitenId();
    if (s) {
      ids.push(s);
    }
    return ids;
  }
  function senden(pfad, daten) {
    return fetch(ROOT + pfad, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(daten)
    }).then(function (antwort) {
      return antwort.json().then(function (json) {
        if (!antwort.ok || (json && json.status && json.status >= 400)) {
          var fehler = new Error((json && (json.description || json.message)) || 'Fehler');
          fehler.amor = (json && json.description) || '';
          throw fehler;
        }
        return json;
      });
    });
  }
  function warenkorb() {
    return fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) {
      return r.json();
    });
  }
  function innen(html, selektor) {
    if (!html) {
      return null;
    }
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var el = doc.querySelector(selektor);
    return el ? el.innerHTML : null;
  }
  function ersetzen(ziel, html) {
    if (ziel && html !== null && html !== undefined) {
      ziel.__amorEigen = true;
      ziel.innerHTML = html;
    }
  }
  // Antwort von Shopify (sections) in Drawer, Zähler und Warenkorbseite einsetzen
  function rendern(sections) {
    if (!sections) {
      return;
    }
    var s = seitenId();
    if (s && sections[s]) {
      ersetzen(seiteElement(), innen(sections[s], '#shopify-section-' + s + ' cart-items'));
    }
    if (sections['cart-drawer']) {
      ersetzen(drawerBody(), innen(sections['cart-drawer'], '#shopify-section-cart-drawer #CartDrawer-Body'));
    }
    if (sections['cart-counter']) {
      var zaehlerEl = document.getElementById('cart-counter');
      var neu = innen(sections['cart-counter'], '#shopify-section-cart-counter');
      if (zaehlerEl && neu !== null) {
        zaehlerEl.innerHTML = neu;
      }
    }
  }
  function beschaeftigt(knopf, an) {
    if (!knopf) {
      return;
    }
    if (an) {
      knopf.setAttribute('aria-busy', 'true');
      knopf.disabled = true;
    } else {
      knopf.removeAttribute('aria-busy');
      knopf.disabled = false;
    }
  }
  function ansagen(text) {
    var region = document.getElementById('AmorWkAnsage');
    if (!region || !text) {
      return;
    }
    region.textContent = '';
    window.setTimeout(function () {
      region.textContent = text;
    }, 120);
  }
  function kurzTitel(titel, marke) {
    var t = String(titel || '');
    var m = String(marke || '').trim();
    if (m && t.toLowerCase().indexOf(m.toLowerCase() + ' ') === 0) {
      t = t.slice(m.length + 1);
      t = t.charAt(0).toUpperCase() + t.slice(1);
    }
    return t;
  }
  function hinzuText(artikel, ersatz) {
    if (!artikel) {
      return ersatz || '';
    }
    var text = kurzTitel(artikel.product_title || artikel.title, artikel.vendor) || ersatz || '';
    var variante = artikel.variant_title;
    if (variante && variante !== 'Default Title') {
      text += ' · ' + variante;
    }
    return text;
  }

  /* ---------- Lieferdatum ---------- */
  function ostern(jahr) {
    var a = jahr % 19;
    var b = Math.floor(jahr / 100);
    var c = jahr % 100;
    var d = Math.floor(b / 4);
    var e = b % 4;
    var f = Math.floor((b + 8) / 25);
    var g = Math.floor((b - f + 1) / 3);
    var h = (19 * a + b - d - g + 15) % 30;
    var i = Math.floor(c / 4);
    var k = c % 4;
    var l = (32 + 2 * e + 2 * i - h - k) % 7;
    var m = Math.floor((a + 11 * h + 22 * l) / 451);
    var n = h + l - 7 * m + 114;
    return new Date(jahr, Math.floor(n / 31) - 1, (n % 31) + 1);
  }
  function tagSchluessel(d) {
    return d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2);
  }
  var feiertagListe = {};
  function feiertage(jahr) {
    if (!feiertagListe[jahr]) {
      var o = ostern(jahr);
      var ab = function (tage) {
        var d = new Date(o.getFullYear(), o.getMonth(), o.getDate() + tage);
        return tagSchluessel(d);
      };
      var liste = {};
      // Neujahr, Karfreitag, Ostermontag, 1. Mai, Himmelfahrt, Pfingstmontag,
      // Fronleichnam (Hessen, Versand ab Hanau), Tag der Einheit, Weihnachten
      [jahr + '-01-01', ab(-2), ab(1), jahr + '-05-01', ab(39), ab(50), ab(60), jahr + '-10-03', jahr + '-12-25', jahr + '-12-26']
        .concat(FREIE_TAGE)
        .forEach(function (k) {
          liste[k] = true;
        });
      feiertagListe[jahr] = liste;
    }
    return feiertagListe[jahr];
  }
  function istWerktag(d) {
    var w = d.getDay();
    return w !== 0 && w !== 6 && !feiertage(d.getFullYear())[tagSchluessel(d)];
  }
  function plusWerktage(start, anzahl) {
    var d = new Date(start.getFullYear(), start.getMonth(), start.getDate());
    var rest = anzahl;
    while (rest > 0) {
      d.setDate(d.getDate() + 1);
      if (istWerktag(d)) {
        rest -= 1;
      }
    }
    return d;
  }
  function datumText(d) {
    if (EN) {
      return T.tage[d.getDay()] + ' ' + d.getDate() + ' ' + T.monate[d.getMonth()];
    }
    return T.tage[d.getDay()] + ', ' + ('0' + d.getDate()).slice(-2) + '.' + ('0' + (d.getMonth() + 1)).slice(-2) + '.';
  }
  function lieferdatum(el) {
    var zeilen = alle('[data-amor-lieferung]', el);
    if (!zeilen.length || !LIEFERUNG) {
      return;
    }
    var heute = new Date();
    var start = heute;
    if (LIEFERUNG.annahmeschluss !== null && heute.getHours() >= LIEFERUNG.annahmeschluss) {
      start = new Date(heute.getFullYear(), heute.getMonth(), heute.getDate() + 1);
    }
    var text = T.lieferung
      .replace('{von}', datumText(plusWerktage(start, LIEFERUNG.von)))
      .replace('{bis}', datumText(plusWerktage(start, LIEFERUNG.bis)));
    zeilen.forEach(function (z) {
      z.textContent = text;
    });
  }

  /* ---------- Hinweise oben in der Liste ---------- */
  function hinweis(art, fett, text) {
    var box = document.createElement('div');
    box.className = 'amor-wk-hinweis amor-wk-hinweis--' + art;
    box.innerHTML = SYMBOL[art === 'fehler' ? 'fehler' : 'ok'];
    var span = document.createElement('span');
    if (fett) {
      var b = document.createElement('strong');
      b.textContent = fett;
      span.appendChild(b);
      span.appendChild(document.createTextNode(' '));
    }
    span.appendChild(document.createTextNode(text));
    box.appendChild(span);
    return box;
  }
  function hinweisWeg(w) {
    var box = document.createElement('div');
    box.className = 'amor-wk-hinweis amor-wk-hinweis--weg';
    var span = document.createElement('span');
    span.textContent = T.weg(w.titel);
    var knopf = document.createElement('button');
    knopf.type = 'button';
    knopf.className = 'amor-wk-link amor-wk-link--fett';
    knopf.setAttribute('data-amor-zurueck', '');
    knopf.textContent = T.zurueck;
    box.appendChild(span);
    box.appendChild(knopf);
    return box;
  }
  function meldungen(el, ort) {
    var box = el.querySelector('[data-amor-meldungen]');
    if (!box) {
      return;
    }
    var runde = zaehler[ort];
    box.textContent = '';
    var h = zustand.hinzu;
    if (h && h.ort === ort && h.runde === runde && Date.now() - h.zeit < 60000) {
      box.appendChild(hinweis('ok', T.hinzu, h.text));
      if (!h.angesagt) {
        h.angesagt = true;
        ansagen(T.hinzu + ' ' + h.text);
      }
    }
    var w = zustand.weg;
    if (w && w.ort === ort && w.runde === runde) {
      box.appendChild(hinweisWeg(w));
      if (!w.angesagt) {
        w.angesagt = true;
        ansagen(T.weg(w.titel));
        var knopf = box.querySelector('[data-amor-zurueck]');
        if (knopf) {
          knopf.focus({ preventScroll: true });
        }
      }
    }
    var m = zustand.meldung;
    if (m && m.ort === ort && m.runde === runde) {
      box.appendChild(hinweis(m.art, '', m.text));
      if (!m.angesagt) {
        m.angesagt = true;
        ansagen(m.text);
      }
    }
  }
  function sofortMeldung(ort, art, text) {
    zustand.meldung = { ort: ort, runde: zaehler[ort], art: art, text: text };
    var el = behaelter(ort);
    if (el) {
      meldungen(el, ort);
      var box = el.querySelector('[data-amor-meldungen]');
      if (box && box.scrollIntoView && ort === 'drawer') {
        box.scrollIntoView({ block: 'nearest' });
      }
    }
  }
  function summenMeldung(el, text) {
    var ziel = el && el.querySelector('[data-amor-meldung]');
    if (ziel) {
      ziel.textContent = text;
      window.clearTimeout(ziel.__amorTimer);
      ziel.__amorTimer = window.setTimeout(function () {
        ziel.textContent = '';
      }, 6000);
    }
  }

  /* ---------- Gutscheincode ---------- */
  function codeFehlerZeigen(box, text) {
    if (!box) {
      return;
    }
    var p = box.querySelector('[data-amor-code-fehler]');
    var eingabe = box.querySelector('[data-amor-code-eingabe]');
    if (p) {
      p.textContent = text;
    }
    if (eingabe) {
      eingabe.setAttribute('aria-invalid', 'true');
      eingabe.focus();
    }
  }
  function codePanel(box, offen, wert) {
    var schalter = box && box.querySelector('[data-amor-code-schalter]');
    if (!schalter) {
      return;
    }
    var feld = document.getElementById(schalter.getAttribute('aria-controls'));
    schalter.setAttribute('aria-expanded', offen ? 'true' : 'false');
    if (feld) {
      feld.hidden = !offen;
      var eingabe = feld.querySelector('[data-amor-code-eingabe]');
      if (eingabe && typeof wert === 'string') {
        eingabe.value = wert;
      }
    }
  }
  function codeZustand(el, ort) {
    var box = el.querySelector('[data-amor-code]');
    if (!box) {
      return;
    }
    var gemerkt = zustand.codeOffen[ort];
    if (gemerkt && gemerkt.offen) {
      codePanel(box, true, gemerkt.wert || '');
    }
    var c = zustand.code;
    if (c && c.ort === ort && c.runde === zaehler[ort]) {
      if (c.fehler) {
        codePanel(box, true, c.wert);
        codeFehlerZeigen(box, c.fehler);
        if (!c.angesagt) {
          c.angesagt = true;
          ansagen(c.fehler);
        }
      } else if (c.ok) {
        summenMeldung(el, c.ok);
        if (!c.angesagt) {
          c.angesagt = true;
          ansagen(c.ok);
        }
      }
    }
  }
  // Schreibweise wie im Admin angelegt (z. B. „AMOR10“), auch wenn klein eingegeben
  function codeTitel(wk, code) {
    var klein = String(code).toLowerCase();
    var titel = '';
    var pruefen = function (a) {
      if (!titel && a && a.type === 'discount_code' && String(a.title || '').toLowerCase() === klein) {
        titel = a.title;
      }
    };
    (wk.cart_level_discount_applications || []).forEach(pruefen);
    (wk.items || []).forEach(function (artikel) {
      (artikel.line_level_discount_allocations || []).forEach(function (z) {
        pruefen(z.discount_application);
      });
    });
    return titel || code;
  }
  function codeEinloesen(box) {
    var ort = ortVon(box);
    var eingabe = box.querySelector('[data-amor-code-eingabe]');
    var knopf = box.querySelector('[data-amor-code-los]');
    var code = String((eingabe && eingabe.value) || '').replace(/,/g, ' ').trim();
    if (!code) {
      codeFehlerZeigen(box, T.codeLeer);
      return;
    }
    beschaeftigt(knopf, true);
    warenkorb()
      .then(function (wk) {
        var codes = wk.discount_codes || [];
        var gleich = function (d) { return String(d.code).toLowerCase() === code.toLowerCase(); };
        if (codes.some(function (d) { return d.applicable && gleich(d); })) {
          var fehler = new Error('schon');
          fehler.amor = T.codeSchon(code);
          throw fehler;
        }
        if (codes.some(gleich)) {
          // schon vorgemerkt (z. B. über den QR-Code), Bedingungen noch nicht erfüllt: nichts ändern
          beschaeftigt(knopf, false);
          zustand.codeOffen[ort] = { offen: false, wert: '' };
          codePanel(box, false, '');
          summenMeldung(behaelter(ort), T.codeSchonVorgemerkt(code));
          ansagen(T.codeSchonVorgemerkt(code));
          return null;
        }
        // vorgemerkte Codes, die (noch) nicht greifen, bleiben erhalten
        var vorher = codes.map(function (d) { return d.code; });
        return senden('cart/update.js', {
          discount: vorher.concat([code]).join(','),
          sections: abschnitte(),
          sections_url: window.location.pathname
        }).then(function (antwort) {
          var treffer = (antwort.discount_codes || []).filter(function (d) {
            return String(d.code).toLowerCase() === code.toLowerCase();
          })[0];
          zustand.codeOffen[ort] = { offen: false, wert: '' };
          if (treffer && treffer.applicable) {
            zustand.code = { ort: ort, runde: zaehler[ort] + 1, ok: T.codeOk(codeTitel(antwort, treffer.code)) };
            rendern(antwort.sections);
            return null;
          }
          // ungültig oder (noch) nicht anwendbar: nur diesen Code wieder entfernen
          return senden('cart/update.js', {
            discount: vorher.join(','),
            sections: abschnitte(),
            sections_url: window.location.pathname
          }).then(function (zurueck) {
            zustand.code = { ort: ort, runde: zaehler[ort] + 1, fehler: T.codeUngueltig(code), wert: code };
            rendern(zurueck.sections);
          });
        });
      })
      .catch(function (fehler) {
        beschaeftigt(knopf, false);
        codeFehlerZeigen(box, (fehler && fehler.amor) || T.fehler);
      });
  }
  function codeEntfernen(knopf) {
    var ort = ortVon(knopf);
    var weg = String(knopf.getAttribute('data-amor-code-weg') || '').toLowerCase();
    beschaeftigt(knopf, true);
    warenkorb()
      .then(function (wk) {
        var rest = (wk.discount_codes || [])
          .map(function (d) { return d.code; })
          .filter(function (c) { return String(c).toLowerCase() !== weg; });
        return senden('cart/update.js', {
          discount: rest.join(','),
          sections: abschnitte(),
          sections_url: window.location.pathname
        });
      })
      .then(function (antwort) {
        zustand.code = { ort: ort, runde: zaehler[ort] + 1, ok: T.codeWeg };
        rendern(antwort.sections);
      })
      .catch(function () {
        beschaeftigt(knopf, false);
        summenMeldung(behaelter(ort), T.fehler);
      });
  }

  /* ---------- Vorgemerkte Codes (QR-Code auf dem Kassenbon, Rabatt-Links) ---------- */
  // Links wie amor.de/discount/CODE merken den Code im Warenkorb vor. Liquid zeigt nur Codes,
  // die schon greifen; solange z. B. der Mindestbestellwert fehlt, sähe der Kunde nichts.
  // Shopify zieht den Code an der Kasse automatisch ab, sobald die Bedingungen erfüllt sind.
  function vorgemerktZeigen(box, codes) {
    alle('[data-amor-code-vorgemerkt]', box).forEach(function (zeile) {
      zeile.parentNode.removeChild(zeile);
    });
    codes.slice().reverse().forEach(function (code) {
      var zeile = document.createElement('div');
      zeile.className = 'amor-wk-code__aktiv amor-wk-code__aktiv--vorgemerkt';
      zeile.setAttribute('data-amor-code-vorgemerkt', '');
      var name = document.createElement('span');
      name.className = 'amor-wk-code__name';
      name.innerHTML = SYMBOL.code;
      var fett = document.createElement('strong');
      fett.textContent = code;
      name.appendChild(fett);
      var text = document.createElement('span');
      text.className = 'amor-wk-code__vormerk';
      text.textContent = T.codeVorgemerkt;
      name.appendChild(text);
      var knopf = document.createElement('button');
      knopf.type = 'button';
      knopf.className = 'amor-wk-link';
      knopf.setAttribute('data-amor-code-weg', code);
      knopf.appendChild(document.createTextNode(T.entfernen));
      var versteckt = document.createElement('span');
      versteckt.className = 'visually-hidden';
      versteckt.textContent = ': ' + T.code + ' ' + code;
      knopf.appendChild(versteckt);
      zeile.appendChild(name);
      zeile.appendChild(knopf);
      box.insertBefore(zeile, box.firstChild);
    });
  }
  function vorgemerkt(el, ort) {
    var box = el.querySelector('[data-amor-code]');
    if (!box) {
      return;
    }
    var runde = zaehler[ort];
    warenkorb()
      .then(function (wk) {
        if (!box.isConnected || zaehler[ort] !== runde) {
          return; // inzwischen neu geladen – der nächste Durchlauf zeigt den aktuellen Stand
        }
        var codes = (wk.discount_codes || [])
          .filter(function (d) { return d && d.code && !d.applicable; })
          .map(function (d) { return String(d.code); });
        vorgemerktZeigen(box, codes);
      })
      .catch(function () {});
  }

  /* ---------- Rückgängig ---------- */
  function entfernenMerken(knopf) {
    var zeile = knopf.closest('[data-amor-zeile]');
    if (!zeile) {
      return;
    }
    var ort = ortVon(zeile);
    var eigenschaften = {};
    try {
      eigenschaften = JSON.parse(zeile.getAttribute('data-eigenschaften') || '{}') || {};
    } catch (e) {
      eigenschaften = {};
    }
    zustand.weg = {
      ort: ort,
      runde: zaehler[ort] + 1,
      id: Number(zeile.getAttribute('data-variante')),
      menge: Number(zeile.getAttribute('data-menge')) || 1,
      eigenschaften: eigenschaften,
      titel: zeile.getAttribute('data-titel') || ''
    };
    zustand.hinzu = null;
  }
  function rueckgaengig(knopf) {
    var w = zustand.weg;
    var ort = ortVon(knopf);
    if (!w || !w.id) {
      return;
    }
    var artikel = { id: w.id, quantity: w.menge };
    if (w.eigenschaften && typeof w.eigenschaften === 'object' && Object.keys(w.eigenschaften).length) {
      artikel.properties = w.eigenschaften;
    }
    beschaeftigt(knopf, true);
    senden('cart/add.js', { items: [artikel], sections: abschnitte(), sections_url: window.location.pathname })
      .then(function (antwort) {
        zustand.weg = null;
        zustand.meldung = { ort: ort, runde: zaehler[ort] + 1, art: 'ok', text: T.wieder(w.titel) };
        rendern(antwort.sections);
      })
      .catch(function (fehler) {
        beschaeftigt(knopf, false);
        sofortMeldung(ort, 'fehler', (fehler && fehler.amor) || T.zurueckFehler);
      });
  }

  /* ---------- Hinzufügen aus „Passt dazu“ / „Zuletzt angesehen“ ---------- */
  function hinzufuegen(knopf) {
    var id = Number(knopf.getAttribute('data-amor-dazu'));
    var ort = ortVon(knopf);
    if (!id) {
      return;
    }
    beschaeftigt(knopf, true);
    senden('cart/add.js', { items: [{ id: id, quantity: 1 }], sections: abschnitte(), sections_url: window.location.pathname })
      .then(function (antwort) {
        var artikel = antwort.items && antwort.items[0];
        zustand.weg = null;
        zustand.hinzu = { ort: ort, runde: zaehler[ort] + 1, text: hinzuText(artikel, knopf.getAttribute('data-titel')), zeit: Date.now() };
        rendern(antwort.sections);
      })
      .catch(function (fehler) {
        beschaeftigt(knopf, false);
        sofortMeldung(ort, 'fehler', (fehler && fehler.amor) || T.dazuFehler);
      });
  }

  /* ---------- „Passt dazu“ und „Zuletzt angesehen“ laden ---------- */
  function produkteHolen(url) {
    if (!cache[url]) {
      cache[url] = fetch(url, { headers: { Accept: 'text/html' } })
        .then(function (r) {
          if (!r.ok) {
            throw new Error(String(r.status));
          }
          return r.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var liste = doc.querySelector('[data-amor-produkte]');
          return {
            quelle: liste ? liste.getAttribute('data-quelle') : '',
            produkte: liste ? Array.prototype.slice.call(liste.children) : []
          };
        })
        .catch(function () {
          delete cache[url];
          return { quelle: '', produkte: [] };
        });
    }
    return cache[url];
  }
  function auswaehlen(listen, ausschliessen, anzahl) {
    var gesehen = {};
    var auswahl = [];
    var stelle = 0;
    var weiter = true;
    while (auswahl.length < anzahl && weiter) {
      weiter = false;
      for (var i = 0; i < listen.length; i += 1) {
        var li = listen[i][stelle];
        if (!li) {
          continue;
        }
        weiter = true;
        var pid = li.getAttribute('data-produkt');
        if (auswahl.length < anzahl && !gesehen[pid] && !ausschliessen[pid] && li.getAttribute('data-verfuegbar') === 'true') {
          gesehen[pid] = true;
          auswahl.push(li);
        }
      }
      stelle += 1;
    }
    return auswahl;
  }
  function einsetzen(box, auswahl, ort) {
    var ul = box.querySelector('[data-amor-pd-liste]');
    if (!ul || !auswahl.length) {
      return;
    }
    ul.textContent = '';
    auswahl.forEach(function (li) {
      var neu = document.importNode(li, true);
      var bild = neu.querySelector('img');
      if (bild && ort === 'drawer') {
        bild.setAttribute('sizes', '56px');
      }
      ul.appendChild(neu);
    });
    box.hidden = false;
  }
  function passtDazu(el, ort) {
    var box = el.querySelector('[data-amor-passt-dazu]');
    if (!box || box.__amorGeladen) {
      return;
    }
    box.__amorGeladen = true;
    var basis = box.getAttribute('data-url') || ROOT + 'recommendations/products';
    var ids = String(box.getAttribute('data-produkte') || '').split(',').filter(Boolean);
    var ausschliessen = {};
    String(box.getAttribute('data-im-warenkorb') || '').split(',').forEach(function (i) {
      if (i) {
        ausschliessen[i] = true;
      }
    });
    var anzahl = parseInt(box.getAttribute('data-anzahl'), 10) || 3;
    var sammlung = box.getAttribute('data-sammlung');
    var adresse = function (id) {
      return basis + '?product_id=' + encodeURIComponent(id) + '&limit=10&intent=complementary&section_id=amor-cart-produkte';
    };
    if (!ids.length) {
      return;
    }
    Promise.all(ids.map(function (id) { return produkteHolen(adresse(id)); }))
      .then(function (ergebnisse) {
        var auswahl = auswaehlen(ergebnisse.map(function (e) { return e.produkte; }), ausschliessen, anzahl);
        if (auswahl.length || !sammlung) {
          return { auswahl: auswahl, beliebt: false };
        }
        // keine gepflegten Ergänzungen: Bestseller anderer Produktarten, passende Zielgruppe
        var typen = liste(box.getAttribute('data-typen'));
        var ziele = liste(box.getAttribute('data-ziele'));
        return produkteHolen(sammlung + '?section_id=amor-cart-produkte').then(function (e) {
          var passend = e.produkte.filter(function (li) {
            var typ = li.getAttribute('data-typ') || '';
            return !(typ && typen[typ]) && passtZiel(li.getAttribute('data-ziel') || '', ziele);
          });
          return { auswahl: auswaehlen([passend], ausschliessen, anzahl), beliebt: true };
        });
      })
      .then(function (ergebnis) {
        if (!box.isConnected || !ergebnis.auswahl.length) {
          return;
        }
        var titel = box.querySelector('[data-amor-pd-titel]');
        if (titel && ergebnis.beliebt && box.getAttribute('data-titel-beliebt')) {
          titel.textContent = box.getAttribute('data-titel-beliebt');
        }
        einsetzen(box, ergebnis.auswahl, ort);
      });
  }
  function liste(text) {
    var menge = {};
    String(text || '').split('|').forEach(function (eintrag) {
      if (eintrag) {
        menge[eintrag] = true;
      }
    });
    return menge;
  }
  // Zielgruppe eines Vorschlags passend zum Warenkorb? (kinder · damen · herren · unisex · leer)
  function passtZiel(ziel, ziele) {
    var erwachsen = ziele.damen || ziele.herren || ziele.unisex;
    if (!ziel || (!erwachsen && !ziele.kinder)) {
      return true;
    }
    if (ziele[ziel]) {
      return true;
    }
    if (ziel === 'kinder') {
      return false;
    }
    if (!erwachsen) {
      return false;
    }
    // Erwachsene: Unisex passt immer; bei reinem Unisex-Warenkorb auch Damen und Herren
    return ziel === 'unisex' || (!!ziele.unisex && !ziele.damen && !ziele.herren);
  }
  function zuletztAngesehen(el, ort) {
    var box = el.querySelector('[data-amor-zuletzt]');
    if (!box || box.__amorGeladen) {
      return;
    }
    box.__amorGeladen = true;
    var handles = [];
    try {
      handles = String(window.localStorage.getItem('recently-viewed') || '').split(',').filter(Boolean);
    } catch (e) {
      handles = [];
    }
    if (!handles.length) {
      return;
    }
    var anzahl = parseInt(box.getAttribute('data-anzahl'), 10) || 3;
    Promise.all(handles.slice(0, anzahl + 3).map(function (h) {
      return produkteHolen(ROOT + 'products/' + encodeURIComponent(h) + '?section_id=amor-cart-produkte');
    })).then(function (ergebnisse) {
      if (!box.isConnected) {
        return;
      }
      var listen = ergebnisse.map(function (e) { return e.produkte; });
      // nacheinander statt abwechselnd: jede Liste hat genau ein Produkt
      var flach = [listen.reduce(function (a, b) { return a.concat(b); }, [])];
      einsetzen(box, auswaehlen(flach, {}, anzahl), ort);
    });
  }

  /* ---------- Handy-Leiste (Warenkorbseite) ---------- */
  var leistenBeobachter = null;
  function leisteEinrichten() {
    var leisten = alle('[data-amor-leiste]');
    if (!leisten.length) {
      return;
    }
    // die frisch aus der Section kommende Leiste gewinnt (Theme-Editor lädt Sections neu)
    var leiste = leisten.filter(function (l) { return l.parentNode !== document.body; })[0] || leisten[0];
    leisten.forEach(function (l) {
      if (l !== leiste) {
        l.remove();
      }
    });
    if (leiste.parentNode !== document.body) {
      document.body.appendChild(leiste);
    }
    leiste.hidden = false;
    leisteAktualisieren();
  }
  function leisteAktualisieren() {
    var leiste = document.querySelector('[data-amor-leiste]');
    if (!leiste) {
      return;
    }
    var haupt = document.querySelector('[data-amor-kasse-haupt]');
    var gesamt = document.querySelector('.amor-wk-summe--seite [data-amor-gesamt]');
    if (leistenBeobachter) {
      leistenBeobachter.disconnect();
      leistenBeobachter = null;
    }
    if (!haupt || !gesamt) {
      leiste.classList.remove('is-sichtbar');
      document.documentElement.classList.remove('amor-wk-leiste-an');
      return;
    }
    var summe = leiste.querySelector('[data-amor-leiste-gesamt]');
    if (summe) {
      summe.textContent = gesamt.textContent.trim();
    }
    var kasse = leiste.querySelector('[data-amor-leiste-kasse]');
    if (kasse) {
      if (haupt.hasAttribute('data-amor-gesperrt')) {
        kasse.setAttribute('aria-disabled', 'true');
        kasse.setAttribute('data-amor-gesperrt', '');
      } else {
        kasse.removeAttribute('aria-disabled');
        kasse.removeAttribute('data-amor-gesperrt');
      }
    }
    if (!('IntersectionObserver' in window)) {
      return;
    }
    leistenBeobachter = new IntersectionObserver(function (eintraege) {
      var imBild = eintraege[eintraege.length - 1].isIntersecting;
      leiste.classList.toggle('is-sichtbar', !imBild);
      document.documentElement.classList.toggle('amor-wk-leiste-an', !imBild);
    }, { rootMargin: '0px 0px -40px 0px' });
    leistenBeobachter.observe(haupt);
  }

  /* ---------- „Zur Kasse“ gesperrt (ausverkaufter Artikel) ---------- */
  function gesperrtHinweis(knopf) {
    var ort = ortVon(knopf);
    if (knopf.closest('[data-amor-leiste]')) {
      ort = 'seite';
    }
    var el = behaelter(ort);
    summenMeldung(el, T.gesperrt);
    ansagen(T.gesperrt);
    var zeile = el && el.querySelector('.amor-wk-artikel--aus');
    if (zeile) {
      if (zeile.scrollIntoView) {
        zeile.scrollIntoView({ block: 'center', behavior: 'smooth' });
      }
      var link = zeile.querySelector('cart-remove-button a');
      if (link) {
        link.focus({ preventScroll: true });
      }
    }
  }

  /* ---------- nach jedem Neuladen von Drawer oder Warenkorbseite ---------- */
  function aufbereiten(el, ort) {
    if (!el) {
      return;
    }
    lieferdatum(el);
    meldungen(el, ort);
    codeZustand(el, ort);
    if (ort === 'seite' || drawerOffen()) {
      vorgemerkt(el, ort);
      passtDazu(el, ort);
      zuletztAngesehen(el, ort);
    }
    if (ort === 'seite') {
      leisteAktualisieren();
    }
  }
  var abgleichTimer = null;
  function andereSeiteAbgleichen(ort) {
    var s = seitenId();
    if (!s) {
      return;
    }
    window.clearTimeout(abgleichTimer);
    abgleichTimer = window.setTimeout(function () {
      var ids = ort === 'drawer' ? [s] : ['cart-drawer'];
      fetch(ROOT + 'cart?sections=' + encodeURIComponent(ids.join(',')), { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(rendern)
        .catch(function () {});
    }, 150);
  }
  function beobachten(el, ort) {
    if (!el || el.__amorBeobachtet) {
      return;
    }
    el.__amorBeobachtet = true;
    new MutationObserver(function () {
      var eigen = el.__amorEigen;
      el.__amorEigen = false;
      zaehler[ort] += 1;
      if (zustand.weg && zustand.weg.ort === ort && zaehler[ort] > zustand.weg.runde) {
        zustand.weg = null;
      }
      aufbereiten(el, ort);
      if (!eigen) {
        // Sahara hat nur diesen Teil neu geladen → den anderen nachziehen (nur auf /cart)
        andereSeiteAbgleichen(ort);
      }
    }).observe(el, { childList: true });
  }

  /* ---------- Ereignisse ---------- */
  // Erfassen, bevor Sahara reagiert
  document.addEventListener('click', function (e) {
    var ziel = e.target;
    if (!ziel || !ziel.closest) {
      return;
    }
    var gesperrt = ziel.closest('[data-amor-gesperrt]');
    if (gesperrt) {
      e.preventDefault();
      e.stopPropagation();
      gesperrtHinweis(gesperrt);
      return;
    }
    var entfernen = ziel.closest('cart-remove-button');
    if (entfernen && entfernen.closest('[data-amor-zeile]')) {
      entfernenMerken(entfernen);
    }
  }, true);

  document.addEventListener('click', function (e) {
    var ziel = e.target;
    if (!ziel || !ziel.closest) {
      return;
    }
    var schalter = ziel.closest('[data-amor-code-schalter]');
    if (schalter) {
      var box = schalter.closest('[data-amor-code]');
      var offen = schalter.getAttribute('aria-expanded') !== 'true';
      codePanel(box, offen);
      zustand.codeOffen[ortVon(schalter)] = { offen: offen, wert: '' };
      if (offen) {
        var eingabe = box.querySelector('[data-amor-code-eingabe]');
        if (eingabe) {
          eingabe.focus();
        }
      }
      return;
    }
    var los = ziel.closest('[data-amor-code-los]');
    if (los) {
      codeEinloesen(los.closest('[data-amor-code]'));
      return;
    }
    var codeWeg = ziel.closest('[data-amor-code-weg]');
    if (codeWeg) {
      codeEntfernen(codeWeg);
      return;
    }
    var zurueck = ziel.closest('[data-amor-zurueck]');
    if (zurueck) {
      rueckgaengig(zurueck);
      return;
    }
    var dazu = ziel.closest('[data-amor-dazu]');
    if (dazu) {
      e.preventDefault();
      hinzufuegen(dazu);
    }
  });

  document.addEventListener('keydown', function (e) {
    var ziel = e.target;
    if (e.key === 'Enter' && ziel && ziel.matches && ziel.matches('[data-amor-code-eingabe]')) {
      e.preventDefault();
      codeEinloesen(ziel.closest('[data-amor-code]'));
    }
  });

  /* ---------- Tastatur im offenen Drawer: Tab bleibt im Drawer, Escape schließt ---------- */
  function fokussierbar(behaelter) {
    return alle('a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]', behaelter)
      .filter(function (el) {
        if (el.getAttribute('tabindex') === '-1' || el.closest('[hidden], [aria-hidden="true"]')) {
          return false;
        }
        return el.getClientRects().length > 0 && window.getComputedStyle(el).visibility !== 'hidden';
      });
  }
  document.addEventListener('keydown', function (e) {
    if ((e.key !== 'Tab' && e.key !== 'Escape') || !drawerOffen()) {
      return;
    }
    var drawer = document.querySelector('cart-drawer');
    var panel = drawer && drawer.querySelector('.cart-drawer__inner');
    if (!panel) {
      return;
    }
    var aktiv = document.activeElement;
    var frei = !aktiv || aktiv === document.body || aktiv === document.documentElement;
    if (!frei && !panel.contains(aktiv)) {
      return; // z. B. das Sahara-Schnellfenster liegt darüber
    }
    if (e.key === 'Escape') {
      if (frei && typeof drawer.close === 'function') {
        drawer.close(); // mit Fokus im Drawer schließt Sahara selbst
      }
      return;
    }
    var liste = fokussierbar(panel);
    if (!liste.length) {
      return;
    }
    var erstes = liste[0];
    var letztes = liste[liste.length - 1];
    if (e.shiftKey && (frei || aktiv === panel || aktiv === erstes)) {
      e.preventDefault();
      letztes.focus();
    } else if (!e.shiftKey && (frei || aktiv === letztes)) {
      e.preventDefault();
      erstes.focus();
    }
  });

  document.addEventListener('input', function (e) {
    var ziel = e.target;
    if (ziel && ziel.matches && ziel.matches('[data-amor-code-eingabe]')) {
      ziel.removeAttribute('aria-invalid');
      var box = ziel.closest('[data-amor-code]');
      var p = box && box.querySelector('[data-amor-code-fehler]');
      if (p) {
        p.textContent = '';
      }
      zustand.codeOffen[ortVon(ziel)] = { offen: true, wert: ziel.value };
    }
  });

  document.addEventListener('change', function (e) {
    var ziel = e.target;
    if (ziel && ziel.matches && ziel.matches('[data-amor-notiz]')) {
      senden('cart/update.js', { note: ziel.value }).catch(function () {});
    }
  });

  /* ---------- Sahara-Drawer und Schnellfenster ergänzen ---------- */
  if (window.customElements && window.customElements.whenDefined) {
    window.customElements.whenDefined('cart-drawer').then(function () {
      var Drawer = window.customElements.get('cart-drawer');
      if (!Drawer || Drawer.prototype.__amor) {
        return;
      }
      Drawer.prototype.__amor = true;
      var oeffnen = Drawer.prototype.open;
      Drawer.prototype.open = function (ausloeser) {
        var vorher = document.activeElement;
        var ergebnis = oeffnen.apply(this, arguments);
        try {
          aufbereiten(drawerBody(), 'drawer');
        } catch (e) {}
        // Fokus in den Drawer holen (Sahara versucht es, erreicht aber kein fokussierbares Element)
        // und merken, wohin er beim Schließen zurück soll (z. B. „In den Warenkorb“).
        try {
          var drawer = this;
          var panel = drawer.querySelector('.cart-drawer__inner');
          if (!ausloeser && vorher && vorher !== document.body && !drawer.contains(vorher) &&
            !vorher.closest('[role="dialog"], quick-cart-modal, .quick-cart-modal')) {
            drawer.activeElement = vorher;
          }
          // Während Saharas Einblend-Animation (300 ms) lässt sich der Drawer noch nicht
          // fokussieren – daher sofort, nach dem Ende der Animation und zur Sicherheit noch einmal.
          var fokus = function () {
            if (panel && drawerOffen() && !panel.contains(document.activeElement)) {
              panel.focus({ preventScroll: true });
            }
          };
          window.setTimeout(fokus, 50);
          window.setTimeout(fokus, 600);
          if (panel) {
            panel.addEventListener('transitionend', function ende(e) {
              if (e.target === panel) {
                panel.removeEventListener('transitionend', ende);
                fokus();
              }
            });
          }
        } catch (e) {}
        return ergebnis;
      };
      var inhalt = Drawer.prototype.renderContents;
      Drawer.prototype.renderContents = function (antwort, oeffnet) {
        var argumente = Array.prototype.slice.call(arguments);
        // Schnellfenster aus einer Produktkachel: nach dem Hinzufügen den Warenkorb öffnen
        // (wie das „+“ bei Produkten ohne Varianten), nicht auf der Warenkorbseite.
        if (oeffnet === false && kachelAuswahl && !seitenId() && !drawerOffen()) {
          oeffnet = true;
          argumente[1] = true;
        }
        try {
          var artikel = antwort && (antwort.items ? antwort.items[0] : antwort);
          if (artikel && (artikel.product_title || artikel.title)) {
            var ort = 'drawer';
            if (oeffnet === false && !drawerOffen() && seitenId()) {
              ort = 'seite';
            }
            zustand.weg = null;
            zustand.hinzu = { ort: ort, runde: zaehler[ort] + 1, text: hinzuText(artikel), zeit: Date.now() };
          }
        } catch (e) {}
        var ergebnis = inhalt.apply(this, argumente);
        // Das Sahara-Schnellfenster gibt beim Schließen das Scrollen der Seite frei –
        // bei offenem Drawer wieder sperren.
        window.setTimeout(function () {
          if (drawerOffen()) {
            document.body.classList.add('overflow-hidden');
          }
        }, 0);
        return ergebnis;
      };
    });
    window.customElements.whenDefined('quick-cart-modal').then(function () {
      var Fenster = window.customElements.get('quick-cart-modal');
      if (!Fenster || Fenster.prototype.__amor || typeof Fenster.prototype.close !== 'function') {
        return;
      }
      Fenster.prototype.__amor = true;
      var schliessen = Fenster.prototype.close;
      Fenster.prototype.close = function () {
        var kachelKnopf = kachelAuswahl;
        kachelAuswahl = null;
        var ergebnis = schliessen.apply(this, arguments);
        if (!drawerOffen() && kachelKnopf && document.contains(kachelKnopf)) {
          // ohne Hinzufügen geschlossen: Fokus zurück auf das „+“ der Kachel – am Desktop ist der
          // Auswahl-Balken nur beim Überfahren sichtbar, dann auf den Produktnamen der Kachel
          window.setTimeout(function () {
            kachelKnopf.focus({ preventScroll: true });
            if (document.activeElement !== kachelKnopf) {
              var kachel = kachelKnopf.closest('card-product');
              var link = kachel && kachel.querySelector('a.card-product__content');
              if (link) {
                link.focus({ preventScroll: true });
              }
            }
          }, 0);
        }
        if (drawerOffen()) {
          document.body.classList.add('overflow-hidden');
          // Fokus zurück in den Drawer: auf „Auswählen“, sonst (nach dem Hinzufügen neu gezeichnet) auf den Drawer
          var ziel = schnellAusloeser && document.contains(schnellAusloeser) ? schnellAusloeser : document.querySelector('cart-drawer .cart-drawer__inner');
          window.setTimeout(function () {
            if (ziel && drawerOffen()) {
              ziel.focus({ preventScroll: true });
            }
          }, 0);
        }
        return ergebnis;
      };
    });
    // „Auswählen“ im Drawer merken (Sahara stoppt den Klick, daher in der Capture-Phase)
    document.addEventListener('click', function (e) {
      var t = e.target && e.target.closest ? e.target.closest('.quick-cart-modal__trigger') : null;
      if (t && t.closest('#CartDrawer-Body')) {
        schnellAusloeser = t;
        kachelAuswahl = null;
      }
    }, true);
    // Produktkacheln mit mehreren Varianten: „+“ bzw. Auswahl-Balken öffnet das Sahara-
    // Schnellfenster (Variantenauswahl). Ohne Schnellfenster geht es zur Produktseite.
    document.addEventListener('click', function (e) {
      var knopf = e.target && e.target.closest ? e.target.closest('[data-amor-kachel-auswahl]') : null;
      if (!knopf) {
        return;
      }
      e.preventDefault();
      e.stopPropagation();
      if (knopf.classList.contains('is--loading') || knopf.__amorWartet) {
        return;
      }
      var zurProduktseite = function () {
        kachelAuswahl = null;
        var kachel = knopf.closest('card-product');
        var link = kachel && kachel.querySelector('a.card-product__media, a.card-product__content');
        window.location.href = link ? link.href : ROOT + (knopf.getAttribute('data-product-url') || '').replace(/^\//, '');
      };
      var oeffnen = function () {
        var fenster = document.querySelector('quick-cart-modal');
        if (!fenster || typeof fenster.fetchProductForQuickCartModal !== 'function') {
          return false;
        }
        kachelAuswahl = knopf;
        try {
          var laden = fenster.fetchProductForQuickCartModal({
            currentTarget: knopf,
            target: knopf,
            preventDefault: function () {},
            stopPropagation: function () {}
          });
          if (laden && typeof laden.catch === 'function') {
            laden.catch(zurProduktseite);
          }
        } catch (fehler) {
          zurProduktseite();
        }
        return true;
      };
      if (oeffnen()) {
        return;
      }
      // Sahara-Skript des Schnellfensters lädt nach dieser Datei: kurz darauf warten, sonst Produktseite
      if (document.querySelector('quick-cart-modal')) {
        var erledigt = false;
        knopf.__amorWartet = true;
        window.customElements.whenDefined('quick-cart-modal').then(function () {
          if (!erledigt) {
            erledigt = true;
            knopf.__amorWartet = false;
            if (!oeffnen()) {
              zurProduktseite();
            }
          }
        });
        window.setTimeout(function () {
          if (!erledigt) {
            erledigt = true;
            knopf.__amorWartet = false;
            zurProduktseite();
          }
        }, 2000);
        return;
      }
      zurProduktseite();
    });
  }

  /* ---------- Start ---------- */
  function einrichten() {
    if (!document.getElementById('AmorWkAnsage')) {
      // span statt div: Sahara blendet leere div-Elemente aus (display: none) –
      // eine ausgeblendete Live-Region würde Ansagen verschlucken
      var region = document.createElement('span');
      region.id = 'AmorWkAnsage';
      region.className = 'visually-hidden';
      region.setAttribute('role', 'status');
      region.setAttribute('aria-live', 'polite');
      document.body.appendChild(region);
    }
    var body = drawerBody();
    if (body) {
      beobachten(body, 'drawer');
      aufbereiten(body, 'drawer');
    }
    var seite = seiteElement();
    if (seite) {
      beobachten(seite, 'seite');
      leisteEinrichten();
      aufbereiten(seite, 'seite');
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', einrichten);
  } else {
    einrichten();
  }
  // Theme-Editor: Section neu geladen
  document.addEventListener('shopify:section:load', function () {
    window.setTimeout(einrichten, 0);
  });

  window.AmorWarenkorb = { version: '2026-10-27', aufbereiten: aufbereiten, lieferdatum: lieferdatum };
})();
